import baseReport from '../baseReport';
import formatDataBR from '@/plugins/filters/formatDataBR';

const aulasMinistradasExigidas = async ({ date, time, filtros, data, professores, indicaanoletivoexcedeu = 'N', anoSubsequente }) => {
const headerFooter = await baseReport({ date, time, title: 'Diário de Classe', subTitle: 'Comparativo de Aulas Ministradas x Exigidas' });
const AnoSubsquente = indicaanoletivoexcedeu === 'S' ? [ { text: '   Ano subsequente:   ', bold: true }, anoSubsequente ] :  []
const dataFormated = []
const observacao = []
const filtrosFormated = [
    {
      text: filtros.nmescola,
      bold: true,
      fontSize: 12,
      alignment: 'center',
      margin: [0, 5, 0, 5],
    },
    {
      fontSize: 12,
      text: (filtros.identificadorperfil == 2) ? [ { text:  'Professor/Educador:   ', bold: true }, professores[0].nmfuncion ] : [],
    },
    {
      fontSize: 12,
      columns: [
        {
          text: [
            { text: 'Ano letivo:  ', bold: true },
            filtros.aaletivo,
            ...AnoSubsquente
          ],
        },
      ],
    }
  ];

  if (data.length <= 0) {
    return {
      ...headerFooter,
      content: [{
        text: 'Nenhuma aula encontrada.',
        fontSize: 10,
        alignment: 'center',
        margin: [0, 15, 0, 0],
        bold: true,
      }],
    };
  }

    const disciplina_array= []
     for(const i in data)
     {
        disciplina_array[i] = [{cddiscipl: data[i].cddiscipl, dsdiscipl: data[i].dsdiscipl}]
     }

    const disciplina_array2 = disciplina_array.filter(function (a) {
        return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
      }, Object.create(null))

      for (const i in disciplina_array2)
      {
            dataFormated.push([
              // {text: 'Disciplina: ' +  disciplina_array2[i][0].dsdiscipl, bold: true, margin: [0,20,0,10]},
              {text: disciplina_array2[i][0].dsdiscipl, bold: true, margin: [0,20,0,10]},
              {
                layout: {fillColor: '#CCCCCC'},
                alignment: 'center',
                table: {
                  headerRows: 1,
                   widths: [ 130, 130, 130, 130 ],

                  body: [
                          [   { text: 'Turma', style: 'tableHeader', fontSize: 12 },
                              { text: 'Aulas mínimas exigidas', style: 'tableHeader' , fontSize: 12  },
                              { text: 'Aulas Ministradas', style: 'tableHeader' , fontSize: 12  },
                              { text: 'Restante', style: 'tableHeader' , fontSize: 12  },
                        ]

                  ]
                }
              },
            ]);
            let disciplina = disciplina_array2[i][0].cddiscipl
            let turma =  data.filter(f => f.cddiscipl === disciplina)
                    for (const j in turma)
                    {
                        let restante = turma[j].qtdeaulaexigida - turma[j].qtdeauladada
                          if ( restante > turma[j].qtdeaulaexigida )
                          {
                            restante = ''
                          }

                          dataFormated.push([
                            {

                              alignment: 'center',
                              table: {
                                widths: [ 130, 130, 130, 130 ],

                                body: [
                                 [ turma[j].turma, turma[j].qtdeaulaexigida, turma[j].qtdeauladada, restante ],
                                ]
                              }
                            },
                          ]);

                    }
      }

      dataFormated.push([
        {
          text: `Obs.: Só é considerado "aula ministrada" a que possui registro de frequência.`, margin: [0,50,0,2], alignment: 'left'  ,
        }
      ]);

  return {
    ...headerFooter,
    content: [
        ...filtrosFormated,
        ...dataFormated,
        ...observacao,
    ],

    styles: {
      tableHeader: {
        bold: true,
        fontSize: 10,
        color: 'black',
        fillColor: '#eeeeee',
        alignment: 'center',
      },
    },
  };
};

export default aulasMinistradasExigidas;
